<template>
    <b-card class="border-0 flex-grow-1" body-class="pb-0 pt-1">
            <span class="d-flex justify-content-center font-weight-bold">{{workshop.name}}</span>
            <div class="d-flex flex-row align-items-stretch">
                <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-row border-bottom">
                        <span class="d-flex">Количество заказов: {{tasksCountValidated}}</span>
                    </div>
                    <div class="d-flex flex-row">
                        <span class="d-flex">Последнее время отдачи: {{lastOrderDoneTimeTime}}</span>
                    </div>
                </div>
                <div v-if="showSOS" class="d-flex ml-1 w-25 text-white justify-content-center align-items-center sos active rounded">SOS</div>
            </div>
    </b-card>
</template>

<script>
import
workshopsQueries
  from '../graphql/workshops'
export default {
  name: 'MotivateWorkshopCard',
  props: {
    workshop: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      motivateResult: null,
      intervalRequest: null
    }
  },
  methods: {
    requestData () {
      this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: workshopsQueries.GET_MOTIVATE_WORKSHOPS,
        variables: {
          workshopType: this.workshop.keyword
        }
      }).then((res) => {
        this.motivateResult = res.data.getMotivateWorkshops
      })
    }
  },
  created () {
    this.requestData()
    this.intervalRequest = setInterval(() => {
      this.requestData()
    }, 60000)
  },
  beforeDestroy () {
    clearInterval(this.intervalRequest)
  },
  computed: {
    tasksCountValidated () {
      if (this.motivateResult) { return this.motivateResult.tasksCount ? this.motivateResult.tasksCount : 0 }
      return 0
    },
    lastOrderDoneTimeTime () {
      if (this.motivateResult) { return this.motivateResult.lastOrderDoneTime !== null ? this.motivateResult.lastOrderDoneTime + ' мин.' : '-' }
      return '-'
    },
    showSOS () {
      if (this.motivateResult) { return this.motivateResult.indicateSos === true }
      return false
    }
  }
}
</script>

<style scoped>
    .sos.active {
        -webkit-animation: blink .5s alternate  infinite;
        animation: blink .5s alternate  infinite;
    }

    @keyframes blink {
        from { background-color: rgb(255, 255, 255); }
        to { background-color: #dc3545 ; }
    }
</style>



// WEBPACK FOOTER //
// src/components/MotivateWorkshopCard.vue